import { render, staticRenderFns } from "./PopulationTrendChart.vue?vue&type=template&id=0639f71a&scoped=true&"
import script from "./PopulationTrendChart.vue?vue&type=script&lang=js&"
export * from "./PopulationTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./PopulationTrendChart.vue?vue&type=style&index=0&id=0639f71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639f71a",
  null
  
)

export default component.exports